<template>
  <div class="display-data _margin-bottom-20">
    {{ value | number(0) }} <small>kWh</small>
    <uiv-btn type="link" size="xs" @click="$emit('onEdit')">Change</uiv-btn>
  </div>
</template>

<script>
export default {
  name: 'UsageDisplay',
  props: {
    value: {
      type: Number | String,
      default: 0
    }
  }
};
</script>

<style lang="scss"></style>
